import { render, staticRenderFns } from "./Edit-oferta.vue?vue&type=template&id=7ce477aa&scoped=true"
import script from "./Edit-oferta.vue?vue&type=script&lang=js"
export * from "./Edit-oferta.vue?vue&type=script&lang=js"
import style0 from "./Edit-oferta.vue?vue&type=style&index=0&id=7ce477aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce477aa",
  null
  
)

export default component.exports